import { io as createSocket, type Socket } from 'socket.io-client';

let _socket: Socket | null = null;

export function getSocket(): Socket {
  if (!_socket) {
    _socket = createSocket({
      path: '/ws',
      withCredentials: true,
      autoConnect: false,
      // Use Socket.io's default transport order: long-polling first, then
      // auto-upgrade to websocket once the connection is live. Many proxies
      // (Cloudflare's free plan among them) silently drop the WebSocket
      // upgrade while passing long-polling HTTP requests. Polling-first
      // means we always get a working real-time connection; WS upgrade is
      // a bonus when the network supports it.
      transports: ['polling', 'websocket'],
      // Keep trying to reconnect if the connection drops.
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      // Don't give up — chat needs persistent real-time.
      reconnectionAttempts: Infinity,
    });
  }
  return _socket;
}

export function connectSocket(): void {
  const s = getSocket();
  if (!s.connected) s.connect();
}

export function disconnectSocket(): void {
  if (_socket) {
    _socket.disconnect();
    _socket = null;
  }
}
